import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceSaveTimeRecordNotificationState = createStateReducer(initialState, {
  [events.saveTimeRecordFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "saveTimeRecord",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceSaveTimeRecordNotificationState };
